import { render, staticRenderFns } from "./ReviewLists.vue?vue&type=template&id=5df701ac&scoped=true&"
import script from "./ReviewLists.vue?vue&type=script&lang=js&"
export * from "./ReviewLists.vue?vue&type=script&lang=js&"
import style0 from "./ReviewLists.vue?vue&type=style&index=0&id=5df701ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df701ac",
  null
  
)

export default component.exports